var $$ = $$ || {};

$$.CardPage = class CardPage {
	constructor (root, options = {}) {
		var defaultOptions = {};

		this.root = root;
		this.options = _.assign(defaultOptions, options);

		this._cacheNodes();
		this._bindEvents();
		this._ready();
	}

	_cacheNodes () {
		this.nodes = {
			goodsCount:       this.root.find('.js-count-goods'),
			addToCart:        this.root.find('.js-add-to-cart'),
			cardImages:       this.root.find('.js-card-images'),
			goodsSet:         this.root.find('.js-set-goods'),
			galleryModal:     this.root.find('.js-gallery-modal')
		};
	}

	_bindEvents () {

		this.nodes.galleryModal.on('hidden.bs.modal', (event) => {
			let modal = $(event.currentTarget);

			modal.find('.modal-body').html('');
		});

		this.nodes.cardImages.on('click', '.item', (event) => {
			"use strict";

			event.preventDefault();

			var item = $(event.currentTarget);

			item.addClass('active');
			item.siblings().removeClass('active');

			if (item.hasClass('video')) {
				this._openModal().find('.modal-body').html(`${$$.makeVideoPlayerHtml(item.data('videoType'), item.data('videoId'), '100%', '342px')}`);
			} else {
				this.nodes.cardImages.find('.big-images .image').html(`<img src="${item.data('original')}" alt="" />`)
			}
		});

		this.nodes.cardImages.on('click', '.big-images .image, .g-icon-zoom', (event) => {
			"use strict";
			event.preventDefault();

			var item = $(event.currentTarget);

			var images = this.nodes.cardImages.find('.small-images .item:not(.video)');
			var items = '';
			images.each((index, element) => {
				var originalImage = $(element).data('original');
				var description = $(element).find('img').attr('alt');
				let descriptionTemplate = '';

				if (description.length !== 0) {
					descriptionTemplate = `<p class="block-description show js-description">${description}</p>`
				} else {
					descriptionTemplate = '';
				}

				items += `<div class="item js-item">
								<div class="image-wrapper">
									<img class="image" src="${originalImage}" alt="">
								</div>
								${descriptionTemplate}
                            </div>`
			});

			var sliderTemplate = `
			<div class="b-content-slider js-content-slider">
                <div class="counter-wrapper">
                    <span class="counter">
                        <span class="js-current-slide">1</span>/<span class="js-count-slides">1</span>
                    </span>
                </div>
                <div class="outer">
                    <div class="arrow-left js-backward">
                        <i class="g-icon g-icon-big-arrow-left icon"></i>
                    </div>
                    <div class="arrow-right js-forward">
                        <i class="g-icon g-icon-big-arrow-right icon"></i>
                    </div>
                    <div class="wrapper">
                        <div class="items js-items">
                            ${items}
                        </div>
                    </div>
                </div>
            </div>
			`;

			this._openModal().find('.modal-body').html(sliderTemplate);

			new $$.ContentSlider(this.nodes.galleryModal.find('.js-content-slider'));
		});

		$$.window.on('resize', () => {
			"use strict";
			this._updateGoodsSet();
		});

		$$.window.resize();
	}

	_updateGoodsSet () {
		"use strict";
		var cards = this.nodes.goodsSet.find('.row.cards').children();
		var goodsSetWidth = this.nodes.goodsSet.width();

		var cardsWidth = cards.outerWidth(true);

		var cardsInserted = parseInt(goodsSetWidth / cardsWidth);

		cards.find('.icon-plus.right').removeClass('hide');
		cards.find('.icon-plus.top').removeClass('show');
		cards.find('.icon-equal').removeClass('top, left');
		cards.find('.icon-equal').addClass('left');

		if (cardsInserted < cards.length) {
			if (cards.length % cardsInserted === 1) {
				cards.filter(`:nth-child(${cardsInserted}n)`).find('.icon-plus.right').addClass('hide');
				cards.filter(`:nth-child(${cardsInserted}n + 1)`).find('.icon-equal').removeClass('top, left');
				cards.filter(`:nth-child(${cardsInserted}n + 1)`).find('.icon-equal').addClass('top');

			} else {
				cards.filter(`:nth-child(${cardsInserted}n)`).find('.icon-plus.right').addClass('hide');
				cards.filter(`:nth-child(${cardsInserted}n + 1)`).find('.icon-plus.top').addClass('show');
				cards.eq(0).find('.icon-plus.top').removeClass('show');
			}
		}
	}

	_openModal () {
		"use strict";

		return this.nodes.galleryModal.modal('show');
	}

	_initGallery () {
		"use strict";
	}

	_closeModal () {
		"use strict";
		return this.nodes.galleryModal.modal('hide');
	}

	_destroyGallery () {
		"use strict";
	}

	_ready () {
		"use strict";
	}
};
